//----------------
// get adj reason
//-----------------
export default function getAdjReason(adj_reason, adj_value) {
  // console.log('--------------------------')
  // console.log('IN getAdjReason reason:', adj_reason, ' value:', adj_value)

  if (
    adj_reason == undefined &&
    adj_value == undefined &&
    adj_reason == null &&
    adj_value == null
  ) {
    return 'Missing adjustment reason or value'
  }

  const reason = adj_reason.charAt(0).toUpperCase() + adj_reason.slice(1)
  const value = ' (' + (adj_value > 0 ? '+' : '') + adj_value.toString() + ')'
  return reason + value
}
